

















import { Component, Prop, Vue } from "vue-property-decorator";

import Language from "./Language.vue";

@Component({ components: { Language } })
export default class extends Vue {
  @Prop(String)
  private description?: string;
  @Prop(Object)
  private language?: object;
  @Prop(String)
  private name: string;
  @Prop(Number)
  private stars: number;
  @Prop(String)
  private url: string;
}
